import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const AuthLayout = () => {
	const isLoggedIn = JSON.parse(localStorage.getItem("logged_in"));

	return (
		isLoggedIn !== true ?
		<div style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minHeight: '100vh',
			backgroundColor: '#f8fafc',
			padding: '2rem',
			margin: 0,
			boxSizing: 'border-box',
			overflowY: 'hidden'
		}}>
			<div style={{
				width: '100%',
				maxWidth: 400,
				background: '#fff',
				borderRadius: 16,
				padding: '2rem',
			}}>
				<Outlet/>
			</div>
		</div> : <Navigate to="/dashboard"/>
	);
}

export default AuthLayout